import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Portal from 'react-portal';
import FullScreenOverlay from './FullScreenOverlay.js';
import {addUsers, setGlobalKey} from "../actions/General";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setCurrentAccount, setCurrentUser, setUserKey} from "../actions/Login";
import newinvoice from "../containers/adm/newinvoice";
import stats from "../containers/adm/stats";
import account_settings from "../containers/adm/account_settings";



const components = {
    newinvoice,
    account_settings,
    stats,
};

class CompanySearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            results : [],
            search:'',
            show:'switch',
        }

        this.login = this.login.bind(this);
        this.search = this.search.bind(this);
        this.changeSearch = this.changeSearch.bind(this);
        this.switch = this.switch.bind(this);
        this.renderComponent = this.renderComponent.bind(this);
        this.show = this.show.bind(this);
    }

    show(s) {
        this.setState({
            show:s
        })
    }

    renderComponent() {
        const Comp = components[this.state.show];
        return <Comp general={this.props.general} />
    }

    componentDidMount() {
        this.refs.s.focus();
    }

    login(account_id) {
        localStorage.setItem('is_staff',true);
        this.props.setGlobalKey('companySearchOpen',false);
        this.props.setCurrentAccount(account_id);
        this.props.router.push(account_id+'/dashboard');
        location.reload();
    }

    changeSearch(e) {
        this.setState({search:e.target.value});
    }

    search(e) {
        if(e.key == 'Enter') {
            axios.get('/users?email='+this.state.search+'&company_name='+this.state.search).then(res => {
                this.setState({results:res.data});
            });
        }
    }

    switch() {
        return (
            <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                <h1>Search for company</h1>
                <h2>Will match e-mail and company name.</h2>

                <div className="m-t-30">
                    <input type="text" ref="s" value={this.state.search} onKeyDown={this.search} onChange={this.changeSearch} className="form-control form-control-lg" placeholder="Babybanden" />
                </div>

                {this.state.results.length > 0 ?
                    <table className="table outline">
                        <thead>
                        <tr>
                            <th>
                                Id
                            </th>
                            <th>
                                E-mail
                            </th>
                            <th>
                                Action
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.results.map(account => {
                            return (
                                <tr key={account.id}>
                                    <td>{account.id}</td>
                                    <td>{account.company_name}</td>
                                    <td>
                                        <button onClick={(e) => {e.stopPropagation(); this.login(account.id)}} className="btn btn-dark btn-sm">{account.company_name}</button>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>:
                    <div className="panel panel-bordered" style={{border:'1px solid #e4eaec'}}>
                        <div className="panel-body text-center" style={{textAlign:'center'}}><br />
                            <i className="icon wb-alert-circle" aria-hidden="true" style={{fontSize:'80px'}}></i>
                            <p>
                                <br />
                                No users or accounts found
                            </p>
                            <br />
                        </div>
                    </div>
                }

            </div>
        );
    }

    render() {
        return <Portal closeOnEsc onClose={this.props.onClose} isOpened={(this.props.param !== false ? true:false)}>
            <FullScreenOverlay>
                <div id="adm">
                    {
                        this.props.isDealer !== true ?
                            <div className="sb">
                                <ul>
                                    <li>Current version: {this.props.general.platform.version}</li>
                                    <li><a href="javascript:void(0)" onClick={(e) => this.show('switch')}>Switch company</a></li>
                                    <li><a href="javascript:void(0)" onClick={(e) => this.show('newinvoice')}>Invoice</a></li>
                                    <li><a href="javascript:void(0)" onClick={(e) => this.show('stats')}>Stats</a></li>
                                    <li><a href="javascript:void(0)" onClick={(e) => this.show('account_settings')}>Account settings</a></li>
                                </ul>
                            </div>:null
                    }

                    <div className="cont">
                        {
                            this.state.show == 'switch' ? this.switch():this.renderComponent()
                        }
                    </div>
                </div>
            </FullScreenOverlay>
        </Portal>
    }

    render2() {
        return <Portal closeOnEsc onClose={this.props.onClose} isOpened={(this.props.param !== false ? true:false)}>
            <FullScreenOverlay>

            </FullScreenOverlay>
        </Portal>
    }
}
const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setUserKey,setCurrentUser},dispatch)
}


CompanySearch = connect(mapStateToProps,mapDispatchToProps)(CompanySearch);
export default CompanySearch;



// WEBPACK FOOTER //
// ./components/CompanySearch.js